import { SERVER_TYPE } from "@/app/constant";

export const environment = {
    production: false,
    env: 'uat',
    server: SERVER_TYPE.ALI,
    // ali cloud
    url: 'https://qakimigatewaybe.schaefflercn.com/wf/gateway/api/app/v2',
    homeUrl: 'https://qakimiworkbench.schaefflercn.com'

    // azure cloud
    // url: 'https://qakimigateway.schaeffler.com/sc/gateway/api/app/',
    // homeUrl: 'https://qakimihome.schaeffler.com'
};
